import { createTypes, createActions } from '@wix/restaurants-redux/dist/actions/ActionCreatorHelper';
import PropTypes                      from 'proptypes';

const socialBarActions = [
    {
        type: 'INIT_STATE',
        propTypes: {}
    },
    {
        type: 'RESIZE_APP',
        propTypes: {
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired,
            type: PropTypes.string
        }
    },
    {
        type: 'SSR_INIT',
        propTypes: {}
    },
    {
        type: 'RESIZE_APP_SUCCESS',
        propTypes: {
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired
        }
    },
    {
        type: 'RESIZE_APP_ENDING',
        propTypes: {}
    },
    {
        type: 'RESIZE_APP_END',
        propTypes: {}
    },
    {
        type: 'SAVE_WINDOW_SIZE',
        propTypes: {
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired
        }
    },
    {
        type: 'SET_VIEW_MODE',
        propTypes: {
            viewMode: PropTypes.string.isRequired
        }
    },
    {
        type: 'SAVE_MANUAL_MODE',
        propTypes: {}
    },
    {
        type: 'SAVE_SIZE',
        propTypes: {
            size: PropTypes.number.isRequired
        }
    },
    {
        type: 'SET_PROPS',
        propTypes: {
            platformList: PropTypes.arrayOf(PropTypes.string).isRequired,
            size: PropTypes.number.isRequired,
            margin: PropTypes.number.isRequired,
            withWrap: PropTypes.bool.isRequired,
            alignment: PropTypes.string.isRequired,
            theme: PropTypes.object.isRequired
        }
    },
    {
        type: 'UPDATE_COMPONENT_SIZE',
        propTypes: {
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired
        }
    },
    {
        type: 'UPDATING_COMPONENT_SIZE',
        propTypes: {}
    },
    {
        type: 'UPDATING_COMPONENT_SIZE_END',
        propTypes: {}
    }
];

const ACTION_PREFIX = 'SOCIAL_BAR_';
export const types   = createTypes(socialBarActions, ACTION_PREFIX);
export const actions = createActions(socialBarActions, ACTION_PREFIX);



// WEBPACK FOOTER //
// ./actions/SocialBarActions.js